import $ from 'jquery';

$(function () {
  function handleScroll() {
    if ($(window).scrollTop() > getScrollOffset()) {
      $('body').addClass('scrolled');
    } else {
      $('body').removeClass('scrolled');
    }
  }

  function getScrollOffset() {
    return ($(window).width() > 991) ? 30 : 10;
  }

  handleScroll();

  $(window).on('resize', function () {
    handleScroll();
  });

  $(window).on('scroll', function () {
    handleScroll();
  });

  $('.back-to-top').on('click', function(e) {
    e.preventDefault();
    // This smoothly scrolls to the top over 300 milliseconds
    $('html, body').animate({ scrollTop: 0, behavior: 'smooth' }, 0); 
  });

  function scrollToHash(targetSelector, duration = 100) {
    const $target = $(targetSelector);
    const navHeight = 148;

    if ($target.length) {
      let scrollTopValue = $target.offset().top - navHeight;

      $('html, body').animate({
        scrollTop: scrollTopValue,
        behavior: 'smooth'
      }, duration); // Adjust the duration (100ms here) as needed
    }
  }

  // Handle clicks on anchor links
  $('body').on('click', 'a[href*="#"]', function(e) {
    // Get the current path and the link path, removing any trailing slashes
    const currentPath = window.location.pathname.replace(/\/+$/, '');
    const linkPath = new URL(this.href).pathname.replace(/\/+$/, '');

    if (currentPath === linkPath) {
      e.preventDefault();

      const duration = $(this).hasClass('scroll-slower') ? 9000 : 100;

      const targetSelector = this.hash;
      scrollToHash(targetSelector, duration);
    }
  });

  // Handle page load with hash
  window.onload = function() {
    if (window.location.hash) {
      const targetSelector = window.location.hash;
      scrollToHash(targetSelector);
    }
  };
});